import { Trial } from '../../../models';

const getTrialTitle = (trial: Trial) => `${trial.task.name} de ${trial.client.name}`;

export default getTrialTitle;
